export default function () {
  const routeTpes = {
    maintenanceBindBankCard: 'maintenanceBindBankCard',
    maintenanceReplaceBankCard: 'maintenanceReplaceBankCard',
    replaceBankCard: 'replaceBankCard',
    bindBankCard: 'bindBankCard',
  }


  const TextMap = new Map([
    [routeTpes.maintenanceBindBankCard, 1], // 维保
    [routeTpes.maintenanceReplaceBankCard, 1], // 维保
    [routeTpes.replaceBankCard, 2], // 代扣
    [routeTpes.bindBankCard, 2], // 代扣
  ])
  const pageType = TextMap.get(this.$route.name)

  const labelNames = {
    accountIdName: {
      1: '付款户ID:',
      2: '资金收款户ID:',
    }[pageType],

    merchantNameFn: {
      1: '付款户公司主体全称',
      2: '资金收款户公司主体全称:',
    }[pageType],

    bankCardNoName: {
      1: '付款银行卡卡号',
      2: '提现银行卡卡号:',
    }[pageType],

    blueBackView: {
      1: '提交银行卡信息后，银行会向您的付款银行卡转入小于等于0.5元的随机金额，并短信通知到经办人手机号，您查看后，需将收到的金额大小，在下一页上回填。银行验证通过后，完成付款账户绑定。',
      2: '提交银行卡信息后，银行会向您的提现银行卡转入小于等于0.5元的随机金额，并短信通知到经办人手机号，您查看后，需将收到的金额大小，在下一页上回填。银行验证通过后，完成提现账户绑定。',
    }[pageType],

    bankCardNoMessage: {
      1: '请填写付款银行卡卡号',
      2: '请填写提现银行卡卡号:',
    }[pageType],

    isMaintenance: {
      1: '付款',
      2: '提现',
    }[pageType],
  }


  return {
    labelNames,
    pageType,
  }
}
